import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentToken } from '../../../app.config';
import {
  StoreTicketPayload,
  Ticket,
  UpdateTicketPayload,
} from '../../models/catalog/ticket.model';

/**
 * Mutation-only — the parent Product detail endpoint already returns
 * its tickets[]. Tickets are not browsed standalone in the FE per plan
 * scope.
 */
@Injectable({ providedIn: 'root' })
export class TicketService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;

  create(payload: StoreTicketPayload): Observable<{ data: Ticket }> {
    return this.#http.post<{ data: Ticket }>(
      `${this.#apiUrl}/api/admin/catalog/tickets`,
      payload,
    );
  }

  update(
    id: number,
    payload: UpdateTicketPayload,
  ): Observable<{ data: Ticket }> {
    return this.#http.patch<{ data: Ticket }>(
      `${this.#apiUrl}/api/admin/catalog/tickets/${id}`,
      payload,
    );
  }

  delete(id: number): Observable<unknown> {
    return this.#http.delete(`${this.#apiUrl}/api/admin/catalog/tickets/${id}`);
  }
}
